import APIConfig from '../../config/api';
import { APIService } from '../axiosInstance';
import { IndustryCodeModel } from 'typings/crm/relationships';
import { FetchParamsModel, FetchResponseModel } from 'typings/common';

interface FetchIndustryCodesParams extends FetchParamsModel {
  search: string;
}

export interface FetchSubIndustriesResponseModel {
  data: {
    [key: string]: {
      codes: string[];
    };
  };
}

const industryCodesAPI = {
  fetchIndustryCodes: (params: FetchIndustryCodesParams) => {
    return APIService.get<FetchResponseModel<IndustryCodeModel>>(
      `${APIConfig.crmApi}/industry-code`,
      { params },
    ).then(({ data }) => data);
  },

  fetchSubIndustriesMap: () => {
    return APIService.get<FetchSubIndustriesResponseModel>(
      `${APIConfig.crmApi}/industry-code/map`,
    ).then(({ data }) => data);
  },
};

export { industryCodesAPI };
